// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17K04","colBig":"styles_colBig__3TrAr","colSmall":"styles_colSmall__2U6KA"};